import { RouteInterface } from "@/common/types";
import WorkExperiences from "./_views/WorkExperiences.vue";

export default [
  {
    path: "workExperiences",
    component: WorkExperiences,
    name: "work-experiences",
    meta: { auth: true },
  },
] as Array<RouteInterface>;
